import type { NodeType } from '../nodes/constants';
import type { NonEmptyArray } from '../types/NonEmptyArray';

export interface DeviceViewSettingsTable {
  label: string;
  webEndpoint: string;
}

export type DeviceViewTablesByNodeType = Partial<
  Record<NodeType | '_any', DeviceViewSettingsTable[]>
>;

export type TableRowSize = 'small' | 'medium' | 'large';

export type TableColumnVisibility = Record<string, boolean>;

export type TableStickyColumns = Record<string, boolean>;

export type TableColumnWidths = Record<string, number>;

export interface TableColumnSort<TColumnKey extends string = string> {
  column: TColumnKey;
  order: 'asc' | 'desc';
}

export type TableSettings = {
  autoSizedColumns?: boolean;
  columnVisibility?: TableColumnVisibility;
  columnWidth?: TableColumnWidths;
  orderedColumns?: NonEmptyArray<string>;
  pagination?: {
    /** -1 is for `Compute` option in the frontend */
    itemsPerPage: number;
  };
  /** Id of remembered single selected row */
  rowAction?: string | number;
  sort?: TableColumnSort;
  stickyColumns?: TableStickyColumns;
};

export type UserTables = Record<string, TableSettings>;

export type UserSettings = {
  diagrams?: {
    tableSetup?: {
      nodes?: DeviceViewTablesByNodeType;
    };
  };
  rowSize?: TableRowSize;
  stickyColumn?: boolean;
  stickyHeader?: boolean;
  pinnedPages?: string[];
};

export type UserSettingsWithTables = UserSettings & {
  tables?: UserTables;
};
